import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import Loading from '../Loading/Loading';
import {Photo} from './MealPhoto.style';

const Status = {
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed'
};

export class MealPhoto extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      status: Status.LOADING
    };
    this.handleOnLoaded = this.handleOnLoaded.bind(this);
    this.handleOnError = this.handleOnError.bind(this);
  }

  handleOnLoaded() {
    this.setState({status: Status.LOADED});
  }

  handleOnError() {
    this.setState({status: Status.FAILED});
  }

  render() {
    const {url, alt} = this.props;
    const renderLoading = this.state.status === Status.LOADING && <Loading />;
    const renderPhoto = this.state.status !== Status.FAILED &&
      <Photo
        src={url}
        onLoad={this.handleOnLoaded}
        onError={this.handleOnError}
        alt={alt}
      />;
    const renderMessage = this.state.status === Status.FAILED && <FormattedMessage id="meal.photo.failed" />;
    return (
      <span>
        {renderLoading}
        {renderPhoto}
        {renderMessage}
      </span>
    );
  }
}

MealPhoto.propTypes = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

export default MealPhoto;



// WEBPACK FOOTER //
// ./components/MealPhoto/MealPhoto.js